import { Component, OnInit } from '@angular/core';
import { EAccess, EAccessMethod } from '@app/access/access.model';
import { Observable, Subscription, of } from 'rxjs';

import { NotificationTask } from '@app/models/notification-settings';
import { NotificationTasksService } from '@app/services/notification-settings';
import { onErrorAlert } from 'common/helper';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-topbar-notification',
    templateUrl: './topbar-notification.component.html',
    standalone: false
})

export class TopbarNotificationComponent implements OnInit {
  public Access = EAccess;
  public AccessMethodKey = EAccessMethod;

  private subs = new Subscription();
  public isNotifiationObs: Observable<boolean> = of(false);

  public unreadTasks$: Observable<NotificationTask[]>;

  constructor(
    private alert: ToastrService,
    public notificationTasksService: NotificationTasksService,
  ) {
    this.initNotification();
  }

  ngOnInit(): void {

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  private initNotification() {
    const sub = this.notificationTasksService.notificationTaskSubject.subscribe(() => {
      this.checkHasNotification();
    });
    this.subs.add(sub);
    this.unreadTasks$ = this.notificationTasksService.notificationsUnreadTasksSubject.asObservable();
    this.notificationTasksService.getMyNotificationTaskList(true).subscribe();
  }

  markNotificationTaskReadAll = () => {
    const sub = this.notificationTasksService.notificationTaskReadAll().subscribe(
      {
        next: () => {
          sub.unsubscribe();
          this.alert.success('All Notification marked as read successfully.');
          this.notificationTasksService.getMyNotificationTaskList().subscribe();

        },
        error: (e) => onErrorAlert(this.alert, e)
      });
    this.subs.add(sub);
  }

  markAsRead = (task: NotificationTask) => {
    const sub = this.notificationTasksService.notificationTaskRead(task.id).subscribe(
      {
        next: () => {
          sub.unsubscribe();
          this.alert.success('Notification marked as read successfully.');
          this.notificationTasksService.getMyNotificationTaskList().subscribe();
        },
        error: (e) => onErrorAlert(this.alert, e)
      });
    this.subs.add(sub);
  }

  private checkHasNotification() {
    this.isNotifiationObs = this.notificationTasksService.hasMyNotificationTask();
  }
}
